import { put, takeLatest } from "redux-saga/effects";
import { translation } from "Helpers/i8n-helper";
import {
    getDonations,
    getDonationsSuccess,
    getDonationsError,
    addOrganization,
    addOrganizationSuccess,
    addOrganizationError,
    donate,
    donationsSuccess,
    donationsError,
    getOraganizations,
    getOraganizationsSuccess,
    getOraganizationsError
} from "../reducers/pledge-reducer";
import { addPledgeOrganization, getAllDonations, makeKoodosDonation, getAllOrganizations, getAllDonationsAndReedeemings } from "../../services/pledge";
import { updateUser } from "../reducers/AuthReducer";
import { message } from "antd";

const t = translation("error");

function* GetDonations() {
    try {
        const response = yield getAllDonations();
        if (response?.success) {
            yield put(getDonationsSuccess(response.donations));
        } else {
            yield put(getDonationsError(t("errorOccurred")));
        }
    } catch (e) {
        console.log("Error fetching donations", e);
        yield put(getDonationsError(t("errorOccurred")));
    }
}

function* GetDonationsAndRedeemings() {
    try {
        const response = yield getAllDonationsAndReedeemings();
        if (response?.success) {
            yield put(getDonationsSuccess(response));
        } else {
            yield put(getDonationsError(t("errorOccurred")));
        }
    } catch (e) {
        console.log("Error fetching donations", e);
        yield put(getDonationsError(t("errorOccurred")));
    }
}

function* GetOrganizations(data) {
    try {
        const response = yield getAllOrganizations({ data: data?.payload });
        if (response?.success) {
            yield put(getOraganizationsSuccess(response));
        } else {
            yield put(getOraganizationsError(t("errorOccurred")));
        }
    } catch (e) {
        console.log("Error fetching donations", e);
        yield put(getOraganizationsError(t("errorOccurred")));
    }
}

function* AddOrganization(action) {
    try {
        const response = yield addPledgeOrganization(action.payload);
        if (response?.user) {
            yield put(updateUser(response.user));
            yield put(addOrganizationSuccess(response.user));
        } else {
            yield put(addOrganizationError(t("errorOccurred")));
        }
    } catch (e) {
        console.log("Error adding organization", e);
        yield put(addOrganizationError(t("errorOccurred")));
    }
}

function* Donate({ payload }) {
    try {
        const response = yield makeKoodosDonation(payload);
        if (response?.success) {
            yield put(updateUser(response.user));
            yield put(donationsSuccess(response));
            // yield put(updateDwollaBalance(payload.dwollaBalance - payload.amount));
            message.success("Donation made successfully");
        } else {
            yield put(donationsError(response?.message || t("errorOccurred")));
        }
    } catch (e) {
        console.log("Error adding organization", e);
        yield put(donationsError(e));
    }
}

function* PledgeSaga() {
    yield takeLatest(getDonations.type, GetDonationsAndRedeemings);
    yield takeLatest(getOraganizations.type, GetOrganizations);
    yield takeLatest(addOrganization.type, AddOrganization);
    yield takeLatest(donate.type, Donate);
}

export default PledgeSaga;
